<template>
     <div class="wraptt">
        <div class="wrap_inner">
            <div class="wrap_main">
                <div class="blkm">
					<a :href="'tel:' + phone" @click="callPhone(phone)" rel="external nofollow" style="position:absolute;top:0;left:0;width: 100%;height: 100%">
						<img src="./image/my-banner@2x.png" style="position:absolute;top:0;left:0;width: 100%;height: 100%" />
						<!-- <img src="./image/my-banner-GJJ.png" style="position:absolute;top:0;left:0;width: 100%;height: 100%" /> -->
					</a>
					<!-- <p>联系电话：<a :href="'tel:' + phone" rel="external nofollow" >{{phone}}</a></p> -->
                   <div class="blkn">
                        <div class="blkj">
							<img src="./image/Avatar@2x.png" class="img1" />
<!-- 							<van-uploader :before-read="beforeRead" :after-read="afterRead" :max-count="3">
							
								<img src="./image/Avatar@2x.png" class="img1" v-if="!imgSrc"></img>
								<img :src="imgSrc" class="img1" v-else style="border-radius:50%"></img>
							</van-uploader> -->
                        </div>
						<div>
							<div class="txt1">{{userName}}</div>
							<div class="subtxt1">{{role==1?'单位对接人':'普通用户'}}</div>
						</div>
                        <!-- <div class="txt1"></div> -->
                   </div>
                </div>
				<div class="ufSty">
					<div class="engSty egSty">
					  <div class="blko1">
					      <div class="blkz"><img src="./image/unit@2x.png" class="imga1"></img></div>
					      <div style="display:flex;flex-direction:column;flex:1;">
					          <div class="txty">单位：{{InfoList.companyName}}</div>
					      </div>
					 </div>
					 <div style="display:flex">
						 <div class="blko">
							 <div class="blkz"><img src="./image/branch@2x.png" class="imga"></img></div>
							 <div style="flex:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">
							     <div class="txty">部门（办公室）</div>
							     <div style="flex:1; overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">{{InfoList.office}}</div>
							 </div>
						 </div>
						 <div class="blko">
							 <div class="blkz"><img src="./image/phone@2x.png" class="imga"></img></div>
							 <div style="flex:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">
							     <div class="txty">手机号码</div>
							     <div style="flex:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">{{InfoList.tel}}</div>
							 </div>
						 </div>
					 </div>
					</div>
				</div>
			   <!-- <div class="yuSty">
					<div>
						<div v-if="userInfo.length>0" class="yuSty">
							<div class="engStym" style="background:linear-gradient(45deg,#5fbef6 1%, #0099ff 97%);" v-for="(item,index) in userInfo" @click="toInfo(item.engineerId)">
								<div>
									<img :src="item.headImg" class="img4" v-if="item.headImg" style="border-radius:50%"></img>
									<img src="@/views/myInfo/image/Avatar1@2x.png" v-else class="img4"></img>
									<div class="gRects"></div>
								</div>
								<div class="blk1">
									<div class="txtn">{{item.name}}&nbsp;<span class="ftSize">{{item.tel}}</span></div>
									<div class="txtn"><div class="ftSize2">{{item.companyName}}</div></div>
								</div>
								<div class="imgkl"><van-icon name="arrow" style="color:#fff" class="imgp" /></div>
							</div>
						</div>
						<div v-else class="nData">暂无数据</div>
					</div>
				</div> -->
				<div class="pEng">
					<div class="pInner" @click="toresponseDetail">
						<div class="flext"><img src="./image/imgt1.png" class="imgt"></img></div>
						<div class="fmSty">我的报修</div>
						<div class="flext"><img src="./image/back@2x.png" class="imgt"></img></div>
					</div>
					<div class="pInner" @click="tochange">
						<div class="flext"><img src="./image/img2.png" class="imgt"></img></div>
						<div class="fmSty">积分兑换</div>
						<div class="flext"><img src="./image/back@2x.png" class="imgt"></img></div>
					</div>
					<div class="pInner" @click="tocomplaint">
						<div class="flext"><img src="./image/img3.png" class="imgt"></img></div>
						<div class="fmSty">投诉</div>
						<div class="flext"><img src="./image/back@2x.png" class="imgt"></img></div>
					</div>
					<div class="pInner" @click="toautograph">
						<div class="flext"><img src="./image/img4.png" class="imgt"></img></div>
						<div class="fmSty">我的签名</div>
						<div class="flext"><img src="./image/back@2x.png" class="imgt"></img></div>
					</div>
				</div>
				<div class="logout" @click="quit">退出登录</div>
				<div @click="toDetail" class="mtmSty">关于淮工深蓝</div>
            </div>
        </div>
     </div>


</template>
<script>
	import {mapActions} from 'vuex'
    import PJXQ from '@/components/pjxq.vue'
    export default{
        components:{PJXQ},
        data(){
            return {
				userInfo:[],
				phone:'4001001529',
                 InfoList:[],
				 userName:'',
				 role:'',
				 file:[],
				 imgSrc:null,
            }
        },
        methods:{
			...mapActions(['LogOut']),
			toInfo(id){
			    this.$router.push({path:'/myInfo',query:{engineerId:id}})
			},
			// 调用拨号功能
			callPhone (phoneNumber) {
			 window.location.href = 'tel://' + phoneNumber
			},
			quit(){
			    this.LogOut()
			},
			toDetail(){
				this.$router.push({path:'/companyInfo'})
			},
            toresponseDetail(){
                this.$router.push({path:'/responseDetail',query:{froms:1}})
            },
            toautograph(){
                this.$router.push('/autograph')
            },
			tocomplaint(){
				this.$router.push('/complaint')
			},
			tochange(){
				this.$toast('暂未上线，敬请期待')
			},
            getData(){
                let data={"userId":this.$store.state.user.userInfo.userId};
                this.$api.get('/app/user/getUser',{params:data}).then(res=>{
                       if(res.data.code=="0000"){
                            let data=res.data.data;
                            this.InfoList=data;
							
                       }
                    }
                )
            },
			//上传前压缩图片
			 async beforeRead(file){//async await 解决异步问题，
					let f = await this.$imgcompress.compressImg(file,file.name,file.type)
					let userId=this.$store.state.user.userInfo.userId
					const formData = new FormData();
					formData.append('esignature',f);
					formData.append('userId',userId)
					formData.append('type',2)
					this.$api.post(`/app/user/insertESignature`,formData,{headers: {'Content-Type': 'multipart/form-data'}}).then (res=>{
						   // if(res.data.code=="0000"&&res.data.data){
						   if(res.data.code=="0000"){
								this.getSign()
						   }
						}
					)
			},
			afterRead(file) {
			},		  
			getSign(){
			  let engineerId=this.$store.state.user.userInfo.userId
			  let data={"userId":engineerId};
			  this.$api.get(`/app/user/getUser`,{params:data}).then(res=>{
			       if(res.data.code=="0000"){
					   if(res.data.data.esignature){
						   this.disShow=0;
						   this.mShow=0
						   this.resultImg=res.data.data.esignature
					   }else{
						   this.disShow=0;
						   this.mShow=1;
					   }
			       }
			    })
		  },
		  getEngData(){
		      let companyId=this.$store.state.user.userInfo.companyId
		      let data={"pointCompanyId":companyId};
		      this.$api.post('/app/user/getEngineerInfo',data).then(res=>{
		             if(res.data.code=="0000"){
		                  let data=res.data.data.datalist;
		  				data.forEach(item=>{
		  					if(item.headImg){
		  						// item.headImg="http://106.15.237.145:9095/prod-yh"+item.headImg
		  						item.headImg=process.env.VUE_APP_IMG_URL+item.headImg
		  						// item.headImg='http://180.100.77.186:9085/prod-yh'+item.headImg
		  					}
		  					
		  				})
		                  this.userInfo=data;
		  				
		             }else{
		  			   this.userInfo=[]
		  		   }
		          }
		      )
		  },
        },
        created(){
			this.userName=this.$store.state.user.userInfo.name
			this.role=this.$store.state.user.userInfo.role
            this.getData()
			this.getSign()
			this.getEngData()
        }
    }
</script>
<style scoped>
	.ftSize{
		font-size:12px;
	}
	.ftSize2{
		font-size:10px;
	}
	.yuSty{
		width:100%;box-sizing: border-box;
	}
	.imgkl{
		width:22px;
		height:22px;
	}
	.blk1{
	   display:flex;
	   flex-direction:column;
	   margin-left:20px;
	}
	.imgp{
	    width:10px;
	    height:14px;
	    color:#fff;
	    font-size:20px;
	}
	.txtn{
		width:200px;
		height:20px;
		overflow:hidden;
	　　text-overflow:ellipsis;
	　　white-space:nowrap;
	    font-size:14px;
	    font-weight:400;
		color:#fff;
		margin-top:5px;
	    /* margin-bottom:px; */
	}
	.gRects{
		position:absolute;
		bottom:12px;
		left:36px;
		width:8px;
		height:8px;
		border-radius:8px;
		background:#09F175;
	}
	.img4{
	    width:32px;
	    height:32px;
		margin-top:6px
	}
	.engStym{
		position:relative;
		display:flex;
		align-items:center;
		padding:9px 12px;
		height:44px;
		width: 309px;
		margin:0px auto;
		margin-bottom:11px;
		background: #ffffff;
		border-radius: 4px;
		box-shadow: 0px 3px 6px 0px rgba(16,82,139,0.16);
		font-size:12px;
	}
	.ufSty{
		position:relative;width:335px;margin:0 auto;height:130px;z-index:2002
	}
	.egSty{
		position:absolute;top:-50px;margin-bottom:0!important;
	}
	.logout{
		margin:30px auto;
		margin-bottom:5px;
		width:281px;
/* 		margin-bottom:20px; */
		height:44px;
		border: 1px solid #ff0000;
		border-radius: 23px;
		font-size: 16px;
		font-weight: 400;
		text-align: left;
		color: #ff0000;
		text-align:center;
		line-height:44px;
	}
     .wraptt{
        position: absolute;
        top: 0;
        left:0;
        width:100%;
        height:100%;
		z-index:2000;
        overflow: auto;
        background:#e9eef2;
		overflow-x:hidden;
    }
	.fmSty{
		flex:1;margin-left:8px;
	}
    .wrap_inner{
         min-height: 100%;
         width:100%;
    }
    .wrap_main{
        padding-bottom: 60px;
    }
	.pEng{
		margin:0px auto;width: 335px;height: 224px;background: #ffffff;border-radius: 4px;box-shadow: 0px 3px 6px 0px rgba(16,82,139,0.16);
	}
	.pInner{
		display:flex;width: 309px;height: 56px;padding:18px 0px;margin:0 auto;background: #ffffff;border-radius: 4px;font-size:12px;box-sizing: border-box;border-bottom:1px solid #cccccc
	}
    .engSty{
        width: 309px;
        height: 108px;
        padding:20px 12px;
        margin:20px auto;
        background: #ffffff;
        border-radius: 4px;
        box-shadow: 0px 3px 6px 0px rgba(16,82,139,0.16);
        font-size:12px;
    }
    .blkm{
    	position:relative;width: 100%;height: 148px;
    }
    .blkn{
    	position:absolute;display:flex;align-items:center;top:46px;left:26px;width:335px;height:56px;
    }
    .blkj{
    	display:flex;flex:0 0 56px;align-items:center;margin-right:16px;
    }
    .img1{
    	width:56px;height:56px;
    }
    .txt1{
		width:280px;height:30px;line-height:30px;
		overflow:hidden;
		　　text-overflow:ellipsis;
		　　white-space:wrap;
    	font-size: 20px;font-weight: 400;text-align: left;color: #ffffff;
    }
	.subtxt1{
		width:280px;height:28px;line-height:28px;
		overflow:hidden;
		　　text-overflow:ellipsis;
		　　white-space:wrap;
		font-size: 12px;
		font-weight: 400;
		text-align: left;
		color: #ffffff;
	}
	.mtmSty{
		width:100px;height:30px;line-height:30px;margin:0 auto;font-size: 14px;font-weight: 600;text-decoration: underline;text-align: center;color: #0080ff;
	}
    .blko{
    	display:flex;justify-content:center;align-items:center;width:100%;height:40px;padding:10px 0;border-bottom:1px solid #CCCCCC;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;
    }
	.blko1{
		display:flex;justify-content:center;align-items:center;width:100%;height:20px;padding:10px 0;border-bottom:1px solid #CCCCCC;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;
	}
    .blkz{
    	display:flex;justify-content:center;flex:0 0 32px;
    }
    .imga{
    	margin-top:-20px;width:16px;height:16px;
    }
	.imga1{
		margin-top:-10px;width:16px;height:16px;
	}
    .txty{
    	flex:1;margin-bottom:8px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;
    }
    .addSty{
    display:flex;height:6px;align-items:center
    }
    .imgt{
        width:22px;height:22px;
    }
    .flext{
       flex:0 0 30px;
    }

</style>
